/**
 * Safely extract array data from API responses
 * Handles various response structures:
 * - res.data (array)
 * - res.data.data (nested array)
 * - res.data.items (array in items property)
 * - res (direct array)
 * - null/undefined/empty objects
 * - Error responses (status >= 400) - returns empty array
 */
export function getDataArray(res) {
    if (!res) return [];

    // If response has an error status (>= 400), return empty array
    // This prevents errors when getDataArray is called on error responses
    if (res.status && res.status >= 400) {
        return [];
    }

    // Direct array
    if (Array.isArray(res)) return res;

    // res.data is array
    if (res.data && Array.isArray(res.data)) return res.data;

    // res.data.data is array (nested structure)
    if (res.data && res.data.data && Array.isArray(res.data.data)) return res.data.data;

    // Common nested keys containing arrays
    const candidateKeys = [
        'items',
        'results',
        'rows',
        'list',
        'groups',
        'centers',
        'students',
        'members',
        'book_lists',
        'templates',
        'appointments',
        'assignments'
    ];
    for (const key of candidateKeys) {
        if (res.data && Array.isArray(res.data[key])) return res.data[key];
    }

    // Empty object or other non-array structure
    return [];
}

/**
 * Safely extract appointments and assignments from appointment API responses
 */
export function getAppointmentsData(res) {
    if (!res || !res.data) return { appointments: [], assignments: [] };

    return {
        appointments: Array.isArray(res.data.appointments) ? res.data.appointments : [],
        assignments: Array.isArray(res.data.assignments) ? res.data.assignments : []
    };
}

